import { jwtDecode } from 'jwt-decode';

import { useChatBodyContext } from 'widget/content/chat/chat-body/chat-body-context';
import { useWidgetContext } from 'widget/widget-context';
import * as Env from 'widget/env';

const useSetTyping = () => {
  const { widget } = useWidgetContext();
  const { accessToken, ws } = useChatBodyContext();

  const setTyping = async () => {
    if (!accessToken) return;
    else if (ws.current?.readyState != 1) return;

    const user = jwtDecode<Env.User>(accessToken);

    ws.current.send(
      JSON.stringify([
        'typing',
        {
          chat_id: widget.instance_chat_key,
          sender_id: user.user_id,
          type: 'typing',
        },
      ]),
    );
  };

  return setTyping;
};

export default useSetTyping;
